import { createApp } from 'vue'
import { createPinia } from 'pinia'
import VueGtag from 'vue-gtag-next'
import { createGtm } from '@gtm-support/vue-gtm'

import App from './app.vue'
import router from './router'
import { useCodeStore } from './stores'

// CSS
import 'sweetalert2/dist/sweetalert2.css'
import './css/style.css'

// Vueアプリを作成
const app = createApp(App)

// Pinia
app.use(createPinia())

// Vue Router
app.use(router)

// Google Analytics
// 設定の詳細はプラグインのドキュメント等を参照。
// https://matteo-gabriele.gitbook.io/vue-gtag/
app.use(VueGtag, { property: { id: 'UA-2393509-1' } })

// GTMの設置
// 設定についてはプラグインのリポジトリを参照。
// https://github.com/gtm-support/vue-gtm
app.use(
  createGtm({
    id: 'GTM-N8QDH7V',
    vueRouter: router,
    vueRouterAdditionalEventData: () => ({
      code: useCodeStore().code,
    }),
    // 開発環境のときはデバッグを出力する
    debug: import.meta.env.DEV,
  }),
)

app.mount('#app')
